function IntegrationDetail() {
  return <div>IntegrationDetail</div>;
}

export default IntegrationDetail;
